import FitnessDataState from '@/components/fitness/FitnessDataState';
import ExerciseProgressPanel from '@/components/fitness/ExerciseProgressPanel';
import { useFitnessResource } from '@/hooks/useFitnessResource';
import { readFitnessHistory } from '@/lib/fitnessData';

async function readExerciseHistory(userId: string, assertCurrent: () => void) {
  const rows = await readFitnessHistory(userId, assertCurrent);
  assertCurrent();
  if (rows.some(row => row.user_id !== userId)) throw new Error('Fitness exercise history owner changed');
  return rows;
}

/** Detail-page adapter; the shared resource discards stale reads immediately on account changes. */
export default function ExerciseProgressHistory({ name, muscle, timed }: { name: string; muscle?: string; timed?: boolean }) {
  const resource = useFitnessResource(readExerciseHistory);
  return <>
    <FitnessDataState status={resource.status} busy={resource.isRefreshing} onRetry={resource.refresh} />
    {resource.status === 'ready' && resource.userId && resource.data && <ExerciseProgressPanel
      key={resource.userId + ':' + name + ':' + muscle} ownerId={resource.userId}
      sessions={resource.data} exercise={{ name, muscle, timed }} asOf={resource.checkedAt ?? undefined} />}
  </>;
}
